import { render, staticRenderFns } from "./draggingElements.vue?vue&type=template&id=78b54450&scoped=true"
import script from "./draggingElements.vue?vue&type=script&lang=js"
export * from "./draggingElements.vue?vue&type=script&lang=js"
import style0 from "./draggingElements.vue?vue&type=style&index=0&id=78b54450&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b411938ae3dba6b80d9ee6ba07c3eefc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b54450",
  null
  
)

export default component.exports